export class OrdemServicoEquipamentoApontamento {
    Id: number;
    OrdemServicoId: number;
    EquipamentoApontamentoId: number;
    Area: number = 0;
    AreaPrevista:number = 0;
    AreaApontada:number = 0;
}
